import type { IconProps } from "../types";

export const Hammer = ({
  size = 24,
  strokeWidth = 2,
  absoluteStrokeWidth,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="butt"
    strokeLinejoin="miter"
    {...props}
  >
    <path d="m15 12-10.5 10.5L2 20 12 9" />
    <path d="m18 15 4-4" />
    <path d="m21.5 11.5-2.5-2.5V6L15.5 2.5 12 3v0H9l1.5 1.5L12 6v4l2 2h2l2.5 2.5" />
  </svg>
);
